import { EditedTask } from "@/types";
import {
  Dispatch,
  MutableRefObject,
  RefObject,
  SetStateAction,
  useEffect,
} from "react";

const useOutsideClick = (
  rowRef: RefObject<HTMLDivElement>,
  createTagOpen: MutableRefObject<boolean>,
  createDueDateOpen: MutableRefObject<boolean>,
  createAssigneeOpen: MutableRefObject<boolean>,
  saveAllowed: MutableRefObject<boolean>,
  editedTaskRef: MutableRefObject<EditedTask | null>,
  handleSave: (editedTask: EditedTask) => Promise<void>,
  setIsEditing: Dispatch<SetStateAction<boolean>>
) => {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      // Do not close if creating a tag
      if (createTagOpen.current === true) {
        return;
      }

      // createDueDateOpen
      if (createDueDateOpen.current === true) {
        return;
      }

      // createAssigneeOpen
      if (createAssigneeOpen.current === true) {
        return;
      }

      // Save the task if allowed
      if (saveAllowed.current === true && editedTaskRef.current) {
        handleSave(editedTaskRef.current);
        return;
      }

      // Close editing if clicked outside
      if (rowRef.current && !rowRef.current.contains(event.target as Node)) {
        setIsEditing(false);
        rowRef.current.style.outline = "";
      }

      saveAllowed.current = false;
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [
    setIsEditing,
    createAssigneeOpen,
    handleSave,
    createTagOpen,
    createDueDateOpen,
    saveAllowed,
    editedTaskRef,
    rowRef,
  ]);
};

export default useOutsideClick;
